/**
 * ERP Billing Warning
 * Inserta un aviso de facturación electrónica en el carrito de compras
 * Válido desde: 26 de diciembre de 2025 hasta 14 de enero de 2026
 */

(function() {
  'use strict';

  // ===============================
  // CONFIGURACIÓN DE FECHAS
  // ===============================
  const startDate = new Date(2025, 11, 27); // Diciembre = 11 (0-indexed)
  const endDate   = new Date(2026, 0, 14);  // Enero = 0
  const today     = new Date();
  
  // Resetear hora para comparación correcta
  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  console.log('Fecha actual:', today.toLocaleDateString());
  console.log('Fecha inicio:', startDate.toLocaleDateString());
  console.log('Fecha fin:', endDate.toLocaleDateString());

  // Si no estamos en el rango de fechas, no hacer nada
  if (today < startDate || today > endDate) {
    console.log('ERP Billing Warning: Fuera del rango de fechas');
    return;
  }

  console.log('ERP Billing Warning: Dentro del rango de fechas - mostrando aviso');

  // ===============================
  // FUNCIÓN PRINCIPAL
  // ===============================
  function insertBillingNotice() {
    // Evitar duplicados
    if (document.getElementById("billing-erp-warning")) {
      console.log('ERP Billing Warning: Ya existe el aviso');
      return;
    }

    // Buscar el checkbox de términos y condiciones
    const termsCheckbox = document.querySelector(
      'input[type="checkbox"][name*="terms"], input[type="checkbox"][name*="conditions"], input[type="checkbox"]'
    );

    if (!termsCheckbox) {
      console.log('ERP Billing Warning: No se encontró el checkbox');
      return;
    }

    console.log('ERP Billing Warning: Checkbox encontrado, creando aviso...');

    // Crear el elemento del aviso
    const notice = document.createElement("div");
    notice.id = "billing-erp-warning";
    notice.style.cssText = `
      background: #fff7e6 !important;
      border: 1px solid #ffe0a3 !important;
      padding: 12px 14px !important;
      border-radius: 6px !important;
      font-size: 13px !important;
      line-height: 1.6 !important;
      margin: 12px 0 10px 0 !important;
      width: 100% !important;
      box-sizing: border-box !important;
      color: #333 !important;
      display: block !important;
    `;

    notice.innerHTML = `
      <p style="margin: 0 0 8px 0; font-size: 13px; line-height: 1.6;">
        Por actualización en nuestro sistema ERP, tu pedido será procesado y despacho normalmente. 
        La Factura Electrónica se emitirá a partir del <strong>15 de enero de 2026</strong>.
      </p>
      <p style="margin: 0; font-size: 13px; line-height: 1.6; color: #666;">
        Gracias por tu comprensión.
      </p>
    `;

    // Obtener el contenedor del checkbox
    const checkboxContainer = termsCheckbox.closest('label') || 
                             termsCheckbox.closest('div') || 
                             termsCheckbox.parentElement;

    // Insertar el aviso ANTES del checkbox
    if (checkboxContainer && checkboxContainer.parentElement) {
      checkboxContainer.parentElement.insertBefore(notice, checkboxContainer);
      console.log('ERP Billing Warning: Aviso insertado correctamente (opción 1)');
    } else if (termsCheckbox.parentElement) {
      termsCheckbox.parentElement.insertBefore(notice, termsCheckbox);
      console.log('ERP Billing Warning: Aviso insertado correctamente (opción 2)');
    }
  }

  // ===============================
  // OBSERVADOR PARA CAMBIOS DINÁMICOS
  // ===============================
  function initObserver() {
    // Intentar insertar inmediatamente
    insertBillingNotice();

    // Crear observador para cambios en el DOM
    const observer = new MutationObserver(function() {
      // Verificar si el aviso ya existe
      if (!document.getElementById("billing-erp-warning")) {
        insertBillingNotice();
      }
    });

    // Configurar el observador
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // ===============================
  // INICIALIZACIÓN
  // ===============================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

})();
